"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var _default = {
  getPaymentCalculatorSummary: {
    resourceType: 'PaymentCalculator_1_0_0',
    paymentCalculatorLabel: 'PAYMENT CALCULATOR',
    vehicleName: 'Outlander sport',
    msrpLabel: 'MSRP',
    ctaText: 'CHANGE MODEL',
    ctaUrl: '/content/mitsubishi-motors/us/en/cars/outlander-phev/new',
    shareOfferLabel: 'Share calculation',
    shareOfferDialogLabel: 'Share your calculation',
    shareDialog: {},
    descriptions: [],
    vehicles: [],
    buyTabLabel: 'BUY',
    leaseTabLabel: 'Lease ',
    downPaymentLabel: 'Down Payment',
    tradeInValueLabel: 'Trade in Value',
    termsLabel: 'Terms (MONTH)',
    interestLabel: 'INTEREST RATE',
    monthlyLabel: 'monthly',
    perMonthLabel: 'per month',
    customRateLabel: 'ENTER CUSTOM RATE',
    defaultRateLabel: 'Default Rate CTA',
    amountFinancedLabel: 'financed',
    amountFinancedInclusionText: 'included available offers and incentives',
    requestQuoteLabel: 'Request a Quote',
    requestTestDriveLabel: 'Test Drive',
    shareCalculationLabel: 'Share',
    seeAllOffersLabel: 'See Special offer',
    annualMileageLabel: 'ANNUAL MILEAGE',
    dueLeasingLabel: 'due at lease signing',
    monthSuffixLabel: '/mo',
    dueLeasingInclusionText: 'includes security deposit and your first month payment',
    calculationErrorTitle: 'Sorry. Finance cant be shown at the moment',
    calculationErrorText: 'Rest assure our top engineers are looking into it. ',
    viewHomePageLabel: 'VIEW HOMEPAGE',
    viewHomePagePath: '/content/mitsubishi-motors/be',
    regexRestrictDecimalPricing: '^\\d*(\\.\\d{1,2})?$',
    errorMessageDownPaymentAndTradeIn: 'Error Message Invalid Input Down Payment or Trade In',
    shareCode: 'YvXh5Jx6oCLz',
    collapseStatus: true,
    disclaimerLabel: 'DISCLAIMERS',
    minimumLoanAllowance: '0',
    minimumLoanAllowanceError: '',
    financeCalculation: {
      downPayment: {},
      tradeInValue: {},
      terms: [],
      rate: null,
      validationRateErrorMsg: '',
      customerCashback: {},
      amountFinanced: {},
      monthlyAmount: {},
      viewSpecialOffersLink: '/en/buy/finance/finance-calculator?zipCode=20011&vehicleCode=RE-PHEV&modelYear=2020',
      requestQuoteRedirectUrl: '/fi?cf_vehicle=RE-PHEV&cf_model=GG2WXDHHZL2M-NA_A02&cf_year=2020&cf_trim=SEL S-AWC 1AT&cf_type=Finance&cf_monthlyPayment=$987.23&cf_amount=$35,540.00&cf_rateOfCustomer=&cf_downPayment=$950.00&cf_terms=36',
      requestTestDriveRedirectUrl: '/fi?cf_vehicle=RE-PHEV&cf_model=GG2WXDHHZL2M-NA_A02&cf_year=2020&cf_trim=SEL S-AWC 1AT&cf_type=Finance&cf_monthlyPayment=$987.23&cf_amount=$35,540.00&cf_rateOfCustomer=&cf_downPayment=$950.00&cf_terms=36'
    },
    leaseCalculation: {
      downPayment: {},
      tradeInValue: {},
      terms: [],
      annualMileage: [],
      dueAtLeasing: {},
      monthlyAmount: {},
      viewSpecialOffersLink: '/en/buy/finance/finance-calculator?zipCode=20011&vehicleCode=RE-PHEV&modelYear=2020',
      requestQuoteRedirectUrl: '/fi?cf_vehicle=RE-PHEV&cf_model=GG2WXDHHZL2M-NA_A02&cf_year=2020&cf_trim=SEL S-AWC 1AT&cf_type=Lease&cf_monthlyPayment=$206.55&cf_amount=$3,930.55&cf_annualMileage=&cf_downPayment=$3,499.00&cf_terms=36',
      requestTestDriveRedirectUrl: '/en/test-drive?step=VariantSelector'
    }
  }
};
exports["default"] = _default;